import { render, staticRenderFns } from "./cancelamento.vue?vue&type=template&id=c824a914"
import script from "./cancelamento.ts?vue&type=script&lang=js&external"
export * from "./cancelamento.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c824a914')) {
      api.createRecord('c824a914', component.options)
    } else {
      api.reload('c824a914', component.options)
    }
    module.hot.accept("./cancelamento.vue?vue&type=template&id=c824a914", function () {
      api.rerender('c824a914', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/manipulacao/cancelamento.vue"
export default component.exports